// Mock data for No61 Cafe website

export const cafeInfo = {
  name: "No61 Cafe",
  tagline: "Mediterranean Flavors, British Comfort",
  description: "A welcoming cafe serving specialty coffee, hearty breakfasts, vibrant salads, and freshly baked goods in the heart of Ashford.",
  hours: {
    cafe: "08:00 - 17:00",
    weekend: "09:00 - 17:00"
  },
  instagram: "@no61cafe",
  phone: "+44 1233 368261",
  mobile: "07878 212998",
  address: "Units 3-4, Cedar Parade, Repton Ave, Ashford TN23 3TE, UK",
  email: "info@no61cafe.com",
  rating: "4.7",
  reviews: "542",
  priceRange: "£10-20"
};

export const menuCategories = [
  {
    id: 1,
    name: "All Day Breakfast",
    items: [
      {
        id: 1,
        name: "Full House",
        description: "Fried egg, bacon, sausage, hash browns, baked beans, mushrooms & grilled tomatoes",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1712746785874-13ec700798cc"
      },
      {
        id: 2,
        name: "Traditional",
        description: "Fried egg, bacon, sausage, grilled tomatoes, mushrooms, hash browns & baked beans",
        price: "£14.99",
        image: "https://images.unsplash.com/photo-1712746785691-56d0c0e6e737"
      },
      {
        id: 3,
        name: "Mediterranean Special",
        description: "Fried egg, halloumi, baby spinach, poached cherry tomatoes & mushrooms",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1712746785768-ae8a10f9a0c0"
      },
      {
        id: 4,
        name: "Sucuklu Yumurta",
        description: "Turkish 3 eggs in the pan with garlic sausage, tomato served with garnish",
        price: "£13.99",
        image: "https://images.unsplash.com/photo-1533089860892-a7c6f0a88666"
      },
      {
        id: 5,
        name: "Vegetarian Delight",
        description: "Fried egg, baby spinach, poached cherry tomatoes, mushrooms, hash browns & baked beans",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1525351484163-7529414344d8"
      },
      {
        id: 6,
        name: "Menemen (Turkish Omelette)",
        description: "Free range tomato & sweet green pepper pan-fried with scrambled eggs",
        price: "£16.99",
        image: "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/kbaclosp_menemen.jpeg"
      }
    ]
  },
  {
    id: 2,
    name: "Luxury Menu",
    items: [
      {
        id: 7,
        name: "Turkish Breakfast",
        description: "Sucuk, halloumi, feta, traditional cheeses, fried egg, honey, clotted cream & more",
        price: "£26.99",
        image: "https://images.unsplash.com/photo-1619546952812-245d23f7c6f8"
      },
      {
        id: 8,
        name: "NO61 Special",
        description: "Ultimate breakfast platter with eggs, bacon, sausages, halloumi, feta & more",
        price: "£29.99",
        image: "https://images.unsplash.com/photo-1484723091739-30a097e8f929"
      }
    ]
  },
  {
    id: 3,
    name: "On Sourdough",
    items: [
      {
        id: 9,
        name: "Eggs Your Way",
        description: "2 free range eggs your way on toasted sourdough",
        price: "£9.49",
        image: "https://images.unsplash.com/photo-1482049016688-2d3e1b311543"
      },
      {
        id: 10,
        name: "Avocholic",
        description: "Smashed avocado with 2 poached eggs on toasted sourdough",
        price: "£12.49",
        image: "https://images.unsplash.com/photo-1551740527-bc191afdd2ef"
      },
      {
        id: 11,
        name: "Med Style",
        description: "Smashed avocado, feta cheese & 2 poached eggs on sourdough",
        price: "£14.99",
        image: "https://images.unsplash.com/photo-1642689690565-bf0afb7eb41e"
      },
      {
        id: 12,
        name: "NO 61 Style",
        description: "Smashed avocado, grilled halloumi & 2 poached eggs on sourdough",
        price: "£14.99",
        image: "https://images.unsplash.com/photo-1725986039230-ab9e02d5b580"
      },
      {
        id: 13,
        name: "Smash It Your Way",
        description: "Smashed avocado, 2 poached eggs, smoked salmon or bacon",
        price: "£16.49",
        image: "https://images.unsplash.com/photo-1724234811975-346af7bc23c1"
      }
    ]
  },
  {
    id: 4,
    name: "Omelettes",
    items: [
      {
        id: 14,
        name: "Plain Omelette",
        description: "4 free range eggs served with chips and salad",
        price: "£9.99",
        image: "https://images.unsplash.com/photo-1612929633738-8fe44f7ec841"
      },
      {
        id: 15,
        name: "Cheese Omelette",
        description: "Cheese & mushroom with chips and salad",
        price: "£11.99",
        image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c"
      },
      {
        id: 16,
        name: "Spinach & Feta Omelette",
        description: "Fresh spinach and feta cheese with chips and salad",
        price: "£13.49",
        image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641"
      }
    ]
  },
  {
    id: 5,
    name: "Brunch",
    items: [
      {
        id: 17,
        name: "Eggs Benedict",
        description: "Toasted sourdough with 2 poached eggs & hollandaise sauce",
        price: "£14.99",
        image: "https://images.unsplash.com/photo-1771344164522-bf348e8cab87"
      },
      {
        id: 18,
        name: "Eggs Royale",
        description: "Toasted sourdough with smoked salmon & 2 poached eggs",
        price: "£15.99",
        image: "https://images.unsplash.com/photo-1768406041776-c5460d9fd638"
      },
      {
        id: 19,
        name: "Eggs Florentine",
        description: "Toasted sourdough with spinach & 2 poached eggs",
        price: "£15.99",
        image: "https://images.unsplash.com/photo-1767425315674-26de4751638f"
      },
      {
        id: 20,
        name: "Try It Our Way",
        description: "Smashed avocado, sautéed spinach, smoked salmon & 2 poached eggs",
        price: "£17.99",
        image: "https://images.unsplash.com/photo-1701887138421-0245712e17e5"
      }
    ]
  },
  {
    id: 6,
    name: "Signatures",
    items: [
      {
        id: 21,
        name: "Manhattan",
        description: "Pancakes served with streaky bacon & 2 fried eggs",
        price: "£15.49",
        image: "https://images.unsplash.com/photo-1528207776546-365bb710ee93"
      },
      {
        id: 22,
        name: "Feeling Hungry",
        description: "Pancakes with eggs, bacon, sausage, hash browns & baked beans",
        price: "£17.49",
        image: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445"
      },
      {
        id: 23,
        name: "French Connection",
        description: "French toast with eggs, sausage, bacon, hash brown & beans",
        price: "£17.49",
        image: "https://images.unsplash.com/photo-1619592982310-7b7d51e4207f"
      }
    ]
  },
  {
    id: 7,
    name: "Sweet & Fruity",
    items: [
      {
        id: 24,
        name: "Blueberry Pancake",
        description: "3 layers of blueberry pancakes with fruits, clotted cream & maple syrup",
        price: "£16.99",
        image: "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/fpwuw2vu_pankek%20bluebery.jpeg"
      },
      {
        id: 25,
        name: "French Toast",
        description: "2 thick cut slices with fruits, clotted cream & maple syrup",
        price: "£15.99",
        image: "https://images.unsplash.com/photo-1619592982366-ed3d55927817"
      },
      {
        id: 26,
        name: "Nutella Dream",
        description: "3 pancakes with Nutella spread, icing sugar, fruits & clotted cream",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1636972678022-ad6f20e43384"
      },
      {
        id: 27,
        name: "Kinder Dream Stack",
        description: "Pancakes with milk & white chocolate, Kinder Bueno pieces",
        price: "£16.99",
        image: "https://images.pexels.com/photos/23371067/pexels-photo-23371067.jpeg"
      },
      {
        id: 28,
        name: "Oreo Overload",
        description: "Pancakes with white chocolate drizzle, crushed Oreo cookies",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1603532648955-039310d9ed75"
      },
      {
        id: 29,
        name: "Biscoff Bliss",
        description: "Pancakes layered with creamy Biscoff sauce & crumbled biscuits",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62"
      },
      {
        id: 30,
        name: "Acai Bowl",
        description: "Brazilian acai palm fruit topped with banana, mixed fruit & coconut granola",
        price: "£15.99",
        image: "https://images.unsplash.com/photo-1590301157890-4810ed352733"
      }
    ]
  },
  {
    id: 8,
    name: "Lunch",
    items: [
      {
        id: 31,
        name: "House Cheese Burger",
        description: "6oz beef burger, cheese, pickled onion, tomato, salad, burger sauce with chips",
        price: "£15.49",
        image: "https://images.unsplash.com/photo-1762631934669-7da9e3100add"
      },
      {
        id: 32,
        name: "Chicken Burger",
        description: "Garlicky marinated chicken in brioche bun with peppers & mayo, served with chips",
        price: "£13.99",
        image: "https://images.unsplash.com/photo-1593759608142-e9b18c0dbe86"
      },
      {
        id: 33,
        name: "O.M.G!!! Burger",
        description: "6oz beef burger, cheese, bacon, fried egg, burger sauce with chips",
        price: "£16.99",
        image: "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/w40gizmn_burger.jpeg"
      },
      {
        id: 34,
        name: "Chicken Schnitzel",
        description: "Panko crusted chicken breast with chips, salad & mushroom sauce",
        price: "£16.99",
        image: "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/jb5whib0_sinitzel%20pic.jpeg"
      },
      {
        id: 35,
        name: "Falafel Burger",
        description: "Hummus, falafel, grilled halloumi, salad in brioche bun with chips",
        price: "£13.99",
        image: "https://images.unsplash.com/photo-1585238341710-209e6ceef0b6"
      }
    ]
  },
  {
    id: 9,
    name: "Wraps & Sandwiches",
    items: [
      {
        id: 36,
        name: "Chicken & Avocado",
        description: "Grilled chicken, smashed avocado, bacon, mayo, leaves in toasted wrap",
        price: "£16.49",
        image: "https://images.unsplash.com/photo-1626700051175-6818013e1d4f"
      },
      {
        id: 37,
        name: "Halloumi & Avocado",
        description: "Grilled halloumi, smashed avocado, roasted peppers in toasted wrap",
        price: "£15.79",
        image: "https://images.unsplash.com/photo-1599599810769-bcde5a160d32"
      },
      {
        id: 38,
        name: "Truffle Club",
        description: "Panko crusted chicken fillet, mayo, bacon, lettuce, tomato on sourdough",
        price: "£17.49",
        image: "https://images.unsplash.com/photo-1539252554453-80ab65ce3586"
      }
    ]
  },
  {
    id: 10,
    name: "Salads",
    items: [
      {
        id: 39,
        name: "Grilled Chicken & Halloumi",
        description: "Chicken, halloumi, mixed lettuce, cucumber, cherry tomatoes, avocado",
        price: "£15.99",
        image: "https://images.unsplash.com/photo-1546793665-c74683f339c1"
      },
      {
        id: 40,
        name: "Mediterranean Salad",
        description: "Mixed lettuce, roasted peppers, cherry tomato, cucumber, olives & feta",
        price: "£14.99",
        image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd"
      },
      {
        id: 41,
        name: "Smoked Salmon & Avocado",
        description: "Mixed greens with salmon, avocado, dressed with olive oil",
        price: "£16.99",
        image: "https://images.unsplash.com/photo-1580822184713-fc5400e7fe10"
      }
    ]
  },
  {
    id: 11,
    name: "Sides",
    items: [
      {
        id: 42,
        name: "Fries",
        description: "Golden crispy fries",
        price: "£4.49",
        image: "https://images.unsplash.com/photo-1576107232684-1279f390859f"
      },
      {
        id: 43,
        name: "Truffle Parmesan Fries",
        description: "Seasoned fries, truffle mayo, grated parmesan & herbs",
        price: "£5.49",
        image: "https://images.unsplash.com/photo-1639024471283-03518883512d"
      },
      {
        id: 44,
        name: "Grilled Halloumi",
        description: "3 pieces halloumi served with garnish & crispy sourdough",
        price: "£6.99",
        image: "https://images.unsplash.com/photo-1631788242181-a3a56c4c16e1"
      },
      {
        id: 45,
        name: "Hummus",
        description: "Served with crispy sourdough",
        price: "£4.99",
        image: "https://images.unsplash.com/photo-1571050095146-bc82ab891d4f"
      }
    ]
  },
  {
    id: 12,
    name: "Kids Menu",
    items: [
      {
        id: 46,
        name: "Kids Breakfast",
        description: "Egg, bacon, sausage & baked beans",
        price: "£9.99",
        image: "https://images.unsplash.com/photo-1551218808-94e220e084d2"
      },
      {
        id: 47,
        name: "Kids Pancakes",
        description: "2 pancakes with fruits, egg, sausage & baked beans",
        price: "£9.99",
        image: "https://images.unsplash.com/photo-1528207776546-365bb710ee93"
      }
    ]
  },
  {
    id: 13,
    name: "Coffees",
    items: [
      {
        id: 48,
        name: "Espresso",
        description: "Double shot espresso",
        price: "£2.99",
        image: "https://images.unsplash.com/photo-1579992357154-faf4bde95b3d"
      },
      {
        id: 49,
        name: "Americano",
        description: "Double shot espresso with hot water",
        price: "£3.79",
        image: "https://images.unsplash.com/photo-1497935586351-b67a49e012bf"
      },
      {
        id: 50,
        name: "Latte",
        description: "Double shot espresso with steamed milk",
        price: "£3.99",
        image: "https://images.unsplash.com/photo-1623086923609-594e98bb0bff"
      },
      {
        id: 51,
        name: "Cappuccino",
        description: "Double shot espresso with foamed milk",
        price: "£4.39",
        image: "https://images.unsplash.com/photo-1761466087993-b111839a8ae5"
      },
      {
        id: 52,
        name: "Mocha",
        description: "Double shot espresso with chocolate and steamed milk",
        price: "£4.49",
        image: "https://images.unsplash.com/photo-1607260550778-aa9d29444ce1"
      },
      {
        id: 53,
        name: "Flat White",
        description: "Double shot espresso with velvety microfoam",
        price: "£3.99",
        image: "https://images.unsplash.com/photo-1528549937-1ae54e8ac906"
      }
    ]
  },
  {
    id: 14,
    name: "Iced Coffees",
    items: [
      {
        id: 54,
        name: "Iced Latte",
        description: "Espresso with cold milk over ice",
        price: "£4.19",
        image: "https://images.unsplash.com/photo-1517487881594-2787fef5ebf7"
      },
      {
        id: 55,
        name: "Iced Americano",
        description: "Espresso with cold water over ice",
        price: "£3.89",
        image: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735"
      },
      {
        id: 56,
        name: "Caramel Macchiato",
        description: "Espresso with vanilla, milk and caramel drizzle over ice",
        price: "£4.99",
        image: "https://images.unsplash.com/photo-1599639957043-f3aa5c986398"
      }
    ]
  },
  {
    id: 15,
    name: "Hot Chocolate & Milkshakes",
    items: [
      {
        id: 57,
        name: "Classic Hot Chocolate",
        description: "Rich hot chocolate with whipped cream",
        price: "£3.99",
        image: "https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed"
      },
      {
        id: 58,
        name: "Strawberry Milkshake",
        description: "Creamy strawberry milkshake",
        price: "£5.99",
        image: "https://images.unsplash.com/photo-1579954115545-a95591f28bfc"
      },
      {
        id: 59,
        name: "Chocolate Chip Milkshake",
        description: "Rich chocolate chip milkshake",
        price: "£5.99",
        image: "https://images.unsplash.com/photo-1572490122747-3968b75cc699"
      }
    ]
  },
  {
    id: 16,
    name: "Smoothies",
    items: [
      {
        id: 60,
        name: "Berry Burst",
        description: "Blackcurrants, blueberries & banana",
        price: "£5.89",
        image: "https://images.unsplash.com/photo-1641893754790-99d96ac55745"
      },
      {
        id: 61,
        name: "Raspberry Heaven",
        description: "Raspberries, blueberries, mango & apple",
        price: "£5.89",
        image: "https://images.pexels.com/photos/6678631/pexels-photo-6678631.jpeg"
      },
      {
        id: 62,
        name: "Passion Storm",
        description: "Passion fruit, papaya, pineapple, peach, guava & aloe vera",
        price: "£5.89",
        image: "https://images.unsplash.com/photo-1595981267035-7b04ca84a82d"
      },
      {
        id: 63,
        name: "Green Reviver",
        description: "Kale, lemongrass, banana & mango",
        price: "£5.89",
        image: "https://images.unsplash.com/photo-1610970881699-44a5587cabec"
      }
    ]
  },
  {
    id: 17,
    name: "Cold Drinks",
    items: [
      {
        id: 64,
        name: "Still Water",
        description: "Kingsdown still water",
        price: "£2.99",
        image: "https://images.unsplash.com/photo-1523362628745-0c100150b504"
      },
      {
        id: 65,
        name: "Sparkling Water",
        description: "Kingsdown sparkling water",
        price: "£2.99",
        image: "https://images.unsplash.com/photo-1548839140-29a749e1cf4d"
      },
      {
        id: 66,
        name: "Fresh Orange Juice",
        description: "Freshly squeezed orange juice",
        price: "£5.99",
        image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba"
      },
      {
        id: 67,
        name: "Soft Drinks",
        description: "Coke, Diet Coke, Fanta, Sprite (330ml bottles)",
        price: "£3.79",
        image: "https://images.unsplash.com/photo-1629203851122-3726ecdf080e"
      }
    ]
  },
  {
    id: 18,
    name: "Mocktails",
    items: [
      {
        id: 68,
        name: "La Mojito Classic",
        description: "Fresh lime, fresh mint, sugar syrup, crushed ice & lemonade",
        price: "£6.99",
        image: "https://images.unsplash.com/photo-1551024601-bec78aea704b"
      },
      {
        id: 69,
        name: "Jolly Berries",
        description: "Mixed berries, vanilla essence, sugar, lemon juice & lemonade",
        price: "£6.99",
        image: "https://images.unsplash.com/photo-1603569283847-aa295f0d016a"
      },
      {
        id: 70,
        name: "Blue Lagoon",
        description: "Fresh lemon juice, blue curacao syrup & lemonade",
        price: "£6.99",
        image: "https://images.unsplash.com/photo-1578308585148-a2c5b9b0cb46"
      }
    ]
  },
  {
    id: 19,
    name: "Desserts",
    items: [
      {
        id: 71,
        name: "Baklava & Ice Cream",
        description: "Traditional baklava with pistachio served with ice cream",
        price: "£9.99",
        image: "https://images.unsplash.com/photo-1519676867240-f03562e64548"
      },
      {
        id: 72,
        name: "Brownie Mess",
        description: "Brownie pieces, gelato, chocolate & strawberry with chocolate sauce",
        price: "£9.95",
        image: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c"
      },
      {
        id: 73,
        name: "Hot Apple Crumble",
        description: "Warm apple crumble served with custard or ice cream",
        price: "£9.95",
        image: "https://images.unsplash.com/photo-1609501676725-7186f017a4b7"
      }
    ]
  },
  {
    id: 20,
    name: "Sundae Dream",
    items: [
      {
        id: 74,
        name: "Choc Fudge Sundae",
        description: "Chocolate gelato, warm fudge flakes, whipped cream & chocolate sauce",
        price: "£12.99",
        image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb"
      },
      {
        id: 75,
        name: "Strawberry Sundae",
        description: "Strawberry gelato, fresh strawberries, whipped cream & strawberry sauce",
        price: "£11.49",
        image: "https://images.unsplash.com/photo-1633933358116-a27b902fad35"
      },
      {
        id: 76,
        name: "Cookies & Cream",
        description: "Cookies & cream gelato, whipped cream, crushed Oreo & chocolate sauce",
        price: "£11.49",
        image: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f"
      }
    ]
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Afternoon Tea",
    date: "Daily",
    time: "14:00 onwards",
    description: "Traditional afternoon tea service available daily from 2 PM. Freshly baked scones, finger sandwiches, and a selection of fine teas",
    capacity: 20,
    price: "£53.8/2 people",
    pricePerPerson: 26.80,
    image: "https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9",
    availableSeats: 20,
    minGuests: 2,
    startTime: "14:00",
    type: "afternoon-tea"
  },
  {
    id: 2,
    title: "Private Event - With Dining",
    date: "Daily",
    time: "17:00 onwards",
    description: "Book the entire venue with full dining service. Minimum order £1000. Perfect for celebrations, corporate events, and special occasions",
    capacity: 70,
    price: "Min £1000",
    minimumOrder: 1000,
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0",
    availableSeats: 70,
    minGuests: 10,
    maxGuests: 70,
    startTime: "17:00",
    type: "with-dining"
  },
  {
    id: 3,
    title: "Venue Hire - Drinks Only",
    date: "Daily",
    time: "17:00 onwards",
    description: "Hire the entire venue for drinks and socializing. £500 venue hire fee. Drinks packages available separately",
    capacity: 70,
    price: "£500",
    venueHire: 500,
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622",
    availableSeats: 70,
    minGuests: 10,
    maxGuests: 70,
    startTime: "17:00",
    type: "drinks-only"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    rating: 5,
    comment: "Absolutely wonderful! The Mediterranean breakfast was delicious and the coffee excellent. Friendly staff and great atmosphere.",
    date: "2024-12-20"
  },
  {
    id: 2,
    name: "James Thompson",
    rating: 5,
    comment: "Best cafe in Ashford! Great menu selection, lovely cooked food, and always a warm welcome. Highly recommend!",
    date: "2024-12-15"
  },
  {
    id: 3,
    name: "Emma Davies",
    rating: 5,
    comment: "Perfect spot for brunch. The Turkish meze platter is amazing and the freshly baked pastries are to die for!",
    date: "2024-12-10"
  },
  {
    id: 4,
    name: "Akif Yilmaz",
    rating: 5,
    comment: "Lezzeti artıran güler yüz ve nazik hizmet anlayışıdır. Biz hepsini NO61 Cafe'de bulduk. Tüm ekibe teşekkür ederiz!",
    date: "2024-12-05"
  }
];

export const gallery = [
  "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/pi8is7oc_no61-cafe-AF1QipMZBDerrvmVlwXQDRsBRGVznU14Xl0YSoXMtm81.jpg",
  "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/5jzl5c9a_HQ0DO5Q8SQO13XBHPMR0.jpg",
  "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/3p2l7cbu_images.jpeg",
  "https://customer-assets.emergentagent.com/job_cafe-events-hub/artifacts/8j2auho1_cafe%2061.jpeg",
  "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4"
];
